import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { createUser, CreateUserPayload } from '../api/users';
import { queryKeys } from '../lib/react-query';

const useCreateUser = () => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (userData: CreateUserPayload) => createUser(userData),
    onSuccess: (_, userData) => {
      setErrorMessage('');
      setSuccess(`Użytkownik o nazwie ${userData.username} został utworzony`);
      queryClient.invalidateQueries({ queryKey: queryKeys.users.all });
    },
    onError: error => {
      setSuccess('');

      if (error instanceof AxiosError) {
        const errors = error.response?.data?.errors;

        if (errors?.username && errors?.email) {
          setErrorMessage(
            'Podana nazwa użytkownika oraz adres email został już wykorzystany'
          );
          return;
        }

        if (errors?.username) {
          setErrorMessage('Podana nazwa użytkownika została już wykorzystana');
          return;
        }

        if (errors?.email) {
          setErrorMessage('Podany adres email został już wykorzystany');
          return;
        }
      }

      setErrorMessage('Wystąpił błąd podczas tworzenia użytkownika');
    },
  });

  const create = async (userData: CreateUserPayload) => {
    setErrorMessage('');
    setSuccess('');

    try {
      await createMutation.mutateAsync(userData);
    } catch {}
  };

  return {
    create,
    errorMessage,
    success,
    setSuccess,
    isPending: createMutation.isPending,
  };
};

export default useCreateUser;
